import { UserState } from '../user.model';

export const initialState: UserState = {};
